import * as type from './type';

export const getAward = (params) => {
  return {
    type: type.GET_AWARD,
    params,
  };
};

export const getAwardSuccess = (payload) => {
  return {
    type: type.GET_AWARD_SUCCESS,
    payload,
  };
};

export const getAwards = (params) => {
  return {
    type: type.GET_AWARDS,
    params,
  };
};

export const getAwardsSuccess = (payload) => {
  return {
    type: type.GET_AWARDS_SUCCESS,
    payload,
  };
};

export const getMyAwardEntry = (params) => {
  return {
    type: type.GET_MY_AWARD_ENTRY,
    params,
  };
};

export const getMyAwardEntrySuccess = (payload) => {
  return {
    type: type.GET_MY_AWARD_ENTRY_SUCCESS,
    payload,
  };
};

export const getAwardEntries = (params) => {
  return {
    type: type.GET_AWARD_ENTRY,
    params,
  };
};

export const getAwardEntriesSuccess = (payload) => {
  return {
    type: type.GET_AWARD_ENTRY_SUCCESS,
    payload,
  };
};

export const registerAwardEntry = (params) => {
  return {
    type: type.REGISTER_AWARD,
    params,
  };
};

export const registerAwardEntrySuccess = (payload) => {
  return {
    type: type.REGISTER_AWARD_SUCCESS,
    payload,
  };
};

export const registerAwardEntryFailed = (payload) => {
  return {
    type: type.REGISTER_AWARD_FAILED,
    payload,
  };
};

export const votingAwardEntry = (params) => {
  return {
    type: type.VOTING_AWARD,
    params,
  };
};

export const votingAwardEntrySuccess = (payload) => {
  return {
    type: type.VOTING_AWARD_SUCCESS,
    payload,
  };
};

export const votingAwardEntryFailed = (payload) => {
  return {
    type: type.VOTING_AWARD_FAILED,
    payload,
  };
};

export const checkVotedAwardEntry = (params) => {
  return {
    type: type.CHECK_VOTED,
    params,
  };
};

export const checkVotedAwardEntrySuccess = (payload) => {
  return {
    type: type.CHECK_VOTED_SUCCESS,
    payload,
  };
};

export const checkVotedAwardEntryFailed = (payload) => {
  return {
    type: type.CHECK_VOTED_FAILED,
    payload,
  };
};

export const deleteAwardEntry = (params) => {
  return {
    type: type.DELETE_AWARD_ENTRY,
    params,
  };
};

export const deleteAwardEntrySuccess = (payload) => {
  return {
    type: type.DELETE_AWARD_ENTRY_SUCCESS,
    payload,
  };
};

export const deleteAwardEntryFailed = (payload) => {
  return {
    type: type.DELETE_AWARD_ENTRY_FAILED,
    payload,
  };
};

export const resetFormRegisterAwardEntry = () => {
  return {
    type: type.RESET_FORM_REGISTER,
  };
};
